<template>
    <div class="condition-content">
        缺省组件
    </div>
</template>

<script>
export default {
  name: 'Placeholder',

  components: {},

  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      ready: true,
    };
  },

  computed: {},

  created() {},

  methods: {
    onChange() {
      this.$emit('change');
    },
  },
};
</script>
